import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MGiftvoucherPriceCategoryService} from './service/m-gift-voucher-price-category.service';
import {MGiftVoucherPriceCategory} from './model/m-gift-voucher-price-category';
import {SnotifyService} from 'ng-snotify';
import {AppSettings} from '../../settings/app-settings';

@Component({
  selector: 'app-gift-voucher-price-category',
  templateUrl: './m-gift-voucher-price-category.component.html'
})
export class MGiftVoucherPriceCategoryComponent implements OnInit, AfterViewInit {

  private mGiftVoucherPriceCategorys: MGiftVoucherPriceCategory [] = [];
  private filter: string;
  private mGiftVoucherPriceCategory: MGiftVoucherPriceCategory;
  private uiMode: string;
  @ViewChild('inputForm') inputForm;

  constructor(private mGiftvoucherPriceCategoryService: MGiftvoucherPriceCategoryService,
              private snotifyService: SnotifyService) {
    this.mGiftVoucherPriceCategory = new MGiftVoucherPriceCategory();
  }

  ngAfterViewInit() {

  }

  ngOnInit() {
    this.uiMode = 'IDEAL';
    this.loadMGiftVoucherPriceCategory();
  }

  sumbmitFormData(): void {
    if (this.inputForm.invalid) {
      this.snotifyService.error('Fill All Input Text', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else {

      this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotifyService.remove(toast.id);
              this.mGiftvoucherPriceCategoryService.save(this.mGiftVoucherPriceCategory).subscribe((mGiftVoucherPriceCategorys) => {
                this.mGiftVoucherPriceCategorys.push(mGiftVoucherPriceCategorys);
                this.snotifyService.success('Gift Voucher Bulk Customer Save Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              }, (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
            }
          },
          {
            text: 'No', action: (toast) => {
              this.snotifyService.remove(toast.id);
            }, bold: true
          },
        ]
      });
    }
  }

  deleteFormData(): void {
    this.snotifyService.confirm('Delete ?..', AppSettings.MESSAGE_WARNING, {
      timeout: 5000,
      showProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      buttons: [
        {
          text: 'Yes', action: (toast) => {
            this.snotifyService.remove(toast.id);
            this.mGiftvoucherPriceCategoryService.delete(this.mGiftVoucherPriceCategory.indexNo).subscribe((data) => {
                this.snotifyService.success('Gift Voucher Bulk Customer Delete Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              },
              (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
          }
        },
        {
          text: 'No', action: (toast) => {
            this.snotifyService.remove(toast.id);
          }, bold: true
        },
      ]
    });
  }

  selectFormData(rowNo, mGiftVoucherPriceCategory: MGiftVoucherPriceCategory) {
    this.uiMode = 'SELECTED';
    this.mGiftVoucherPriceCategory = mGiftVoucherPriceCategory;
    this.mGiftVoucherPriceCategorys.splice(rowNo, 1);
  }

  newFormData(): void {
    this.uiMode = 'EDIT';
  }

  clearFormData(): void {
    this.inputForm.reset();
    this.uiMode = 'IDEAL';
    this.loadMGiftVoucherPriceCategory();
  }

  loadMGiftVoucherPriceCategory(): void {
    this.mGiftVoucherPriceCategory.createDate = new Date();
    this.mGiftvoucherPriceCategoryService.findAll().subscribe((mGiftVoucherPriceCategorys) => {
        this.mGiftVoucherPriceCategorys = mGiftVoucherPriceCategorys;
      },
      (e) => {
        this.mGiftVoucherPriceCategorys = [];
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher-price-category/m-gift-voucher-price-category.component.ts